/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUserManagementRemoveUsersFromGroupMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementRemoveUserFromGroupInput
  }>

export type BackofficeUserManagementRemoveUsersFromGroupMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementRemoveUserFromGroup: {
    __typename?: 'BackofficeUser'
    id: string
  }
}

export const BackofficeUserManagementRemoveUsersFromGroupDocument = gql`
    mutation BackofficeUserManagementRemoveUsersFromGroup($input: BackofficeUserManagementRemoveUserFromGroupInput!) {
  backofficeUserManagementRemoveUserFromGroup(input: $input) {
    id
  }
}
    `
export type BackofficeUserManagementRemoveUsersFromGroupMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementRemoveUsersFromGroupMutation,
    BackofficeUserManagementRemoveUsersFromGroupMutationVariables
  >

/**
 * __useBackofficeUserManagementRemoveUsersFromGroupMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementRemoveUsersFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementRemoveUsersFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementRemoveUsersFromGroupMutation, { data, loading, error }] = useBackofficeUserManagementRemoveUsersFromGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementRemoveUsersFromGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementRemoveUsersFromGroupMutation,
    BackofficeUserManagementRemoveUsersFromGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementRemoveUsersFromGroupMutation,
    BackofficeUserManagementRemoveUsersFromGroupMutationVariables
  >(BackofficeUserManagementRemoveUsersFromGroupDocument, options)
}
export type BackofficeUserManagementRemoveUsersFromGroupMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementRemoveUsersFromGroupMutation>
export type BackofficeUserManagementRemoveUsersFromGroupMutationResult =
  Apollo.MutationResult<BackofficeUserManagementRemoveUsersFromGroupMutation>
export type BackofficeUserManagementRemoveUsersFromGroupMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementRemoveUsersFromGroupMutation,
    BackofficeUserManagementRemoveUsersFromGroupMutationVariables
  >
